"use client"

import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { useEffect, useState } from "react"

const KEY = "amz_cookie_notice"

/**
 * Informative cookie notice. The shop only sets technical cookies, which do
 * not need consent (LSSI art. 22.2), so it just informs and can be closed.
 */
export default function CookieNotice() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    try {
      setVisible(!localStorage.getItem(KEY))
    } catch {
      setVisible(false)
    }
  }, [])

  if (!visible) return null

  const close = () => {
    try {
      localStorage.setItem(KEY, "1")
    } catch {}
    setVisible(false)
  }

  return (
    <div
      role="region"
      aria-label="Aviso de cookies"
      className="fixed bottom-0 inset-x-0 z-[60] bg-zl-black text-zl-canvas text-xs small:text-sm px-5 py-4 border-t border-zl-line-dark flex flex-col small:flex-row items-center justify-center gap-3"
      data-testid="cookie-notice"
    >
      <p className="text-center">
        Solo usamos cookies técnicas necesarias para la cesta, el inicio de sesión y el pago. No
        usamos cookies de analítica ni publicidad.{" "}
        <LocalizedClientLink href="/legal/cookies" className="underline">
          Más información
        </LocalizedClientLink>
      </p>
      <button onClick={close} className="zl-btn-base h-9 px-6 bg-white text-zl-ink hover:bg-zl-red hover:text-white" data-testid="cookie-notice-close">
        Entendido
      </button>
    </div>
  )
}
